import request from '@/utils/request'

export function changeRoomRequireApi(query, path) {
  return request({
    url: `/chamber-service/v1/room-require/${path}`,
    method: 'put',
    data: query
  })
}

export function newRequestRoomRequireApi(id) {
  return request({
    url: '/chamber-service/v1/room-require/new-request',
    method: 'put',
    params: {
      id: id
    }
  })
}
